import React, { useEffect, useRef } from 'react'
import Chart from 'chart.js/auto'
import { buildTopQuestionsChart } from 'tabs/topQuestions/components/top_questions_historical_data_initializer/top-questions.chart-builder'
import { useSelector } from 'react-redux'
import { findHoveredClusterId, selectClusterColorsMap, selectClustersNameMap } from 'tabs/topQuestions/lib/top_questions/topQuestionsSelectors'
import { selectQuestionTypeFilter } from 'tabs/topQuestions/lib/top_questions_search/topQuestionsSearchSelectors'
import { ClusteringExecutionData } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusTypes'
import { convertQuestionDataToChart } from 'tabs/topQuestions/lib/question_clusters_line_chart/questionClustersLineChartConverter'


type TopQuestionLineChartProps = {
  lineChartData: ClusteringExecutionData[]
}

export const TopQuestionsLineChart = ({ lineChartData }: TopQuestionLineChartProps) => {

  const htmlCanvasElement = useRef<HTMLCanvasElement | undefined>()
  const chartRef = useRef<Chart>(null)
  const selectedQuestionType = useSelector(selectQuestionTypeFilter)
  const hoveredClusterId = useSelector(findHoveredClusterId)
  const clustersNamesMap = useSelector(selectClustersNameMap)
  const clusterColorMap = useSelector(selectClusterColorsMap)

  useEffect(() => {
    const htmlCanvasElementPresent = htmlCanvasElement.current != undefined
    if (htmlCanvasElementPresent) {
      const chartWasNotCreated = chartRef.current == undefined
      const lineChartDataPresent = lineChartData != undefined && lineChartData.length != 0
      const clusterColorMapPresent = clusterColorMap != undefined
      if (chartWasNotCreated && lineChartDataPresent && clusterColorMapPresent) {
        const data = convertQuestionDataToChart(lineChartData, clusterColorMap, clustersNamesMap, selectedQuestionType, hoveredClusterId)

        const chartConfiguration = buildTopQuestionsChart(data)
        chartRef.current = new Chart(htmlCanvasElement.current, chartConfiguration)
        chartRef.current.render()
      } else if (lineChartData != undefined) {
        chartRef.current.data = convertQuestionDataToChart(lineChartData, clusterColorMap, clustersNamesMap, selectedQuestionType, hoveredClusterId)
        chartRef.current.update()
      }
    }
  }, [lineChartData, htmlCanvasElement.current, hoveredClusterId, clusterColorMap, JSON.stringify(clustersNamesMap)])


  return <div className={'questionClusterChartWrapper'}>
    <canvas height={280} ref={htmlCanvasElement} />
  </div>
}
